export const EmailIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 18 14"
			fill="currentColor"
		>
			<path d="M15.9971 12.8095V13.37H1.4004V12.8095H15.9971ZM16.838 11.9696V1.27508C16.838 1.10463 16.6384 1.0123 16.5085 1.12265L10.1748 6.50287C9.32358 7.22605 8.07395 7.22605 7.22268 6.50287L0.889055 1.12265C0.759146 1.0123 0.559572 1.10463 0.559572 1.27508V11.9696C0.559572 12.4335 0.936475 12.8095 1.4004 12.8095V13.37L1.25684 13.3622C0.550913 13.2905 0 12.6945 0 11.9696V1.4C0 0.6268 0.626801 0 1.4 0H15.9975C16.7707 0 17.3975 0.626801 17.3975 1.4V11.9696C17.3975 12.6945 16.8466 13.2905 16.1407 13.3622L15.9971 13.37V12.8095C16.4611 12.8095 16.838 12.4335 16.838 11.9696ZM7.58499 6.07612C8.22717 6.62168 9.17036 6.62167 9.81254 6.07612L15.8909 0.911984C16.0328 0.791481 15.9475 0.559565 15.7614 0.559565H1.6361C1.44999 0.559565 1.36477 0.791481 1.50661 0.911984L7.58499 6.07612Z" />
			<path d="M6.80957 5.90195L3.87442 8.86913C3.76573 8.97901 3.5886 8.98014 3.47852 8.87167C3.36847 8.76271 3.36754 8.58518 3.47643 8.47506L6.41113 5.50742L6.80957 5.90195Z" />
			<path d="M10.4111 5.90195L13.3463 8.86913C13.455 8.97901 13.6321 8.98014 13.7422 8.87167C13.8522 8.76271 13.8532 8.58518 13.7443 8.47506L10.8096 5.50742L10.4111 5.90195Z" />
		</svg>
	);
};
